export const usuarioValorInativo = (ativo) => ativo === false || ativo === "false"

export const usuarioImpactoInativacaoExtrair = (oDados = {}) => ({
  nConversasAtivasComoResponsavel: oDados.nConversasAtivasComoResponsavel ?? 0,
  nFilasComoResponsavel: oDados.nFilasComoResponsavel ?? oDados.nFilasAtribuidas ?? 0,
})

export const usuarioRespostaInativacaoEhConflito = (oErro) =>
  oErro?.response?.status === 409 && oErro?.response?.data?.lPossuiConversasAbertas !== undefined
